interface TitleMetaDescriptionsData {
	url: string;
	title: string;
	descriptionNew: string;
	id: string;
	timestampRequired: boolean;
}

export const titleMetaDescriptionsData: TitleMetaDescriptionsData[] = [
	{
		url: 'https://www.justwatch.com/uk/movie/tiger-3',
		title: 'Tiger 3 - movie: where to watch streaming online',
		descriptionNew:
			'Find where to watch Tiger 3 on streaming services such as Netflix, Prime Video & BBC iPlayer. Streaming options were updated on',
		id: 'tm947849',
		timestampRequired: true,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/love-actually',
		title: 'Love Actually - movie: watch streaming online',
		descriptionNew:
			'Where to watch Love Actually on streaming services such as Netflix, Prime Video and BBC iPlayer. Streaming options were updated on',
		id: 'tm133767',
		timestampRequired: true,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/millers-girl',
		title: "Miller's Girl - movie: watch streaming online",
		descriptionNew:
			"Where to watch Miller's Girl on streaming services such as Netflix, Prime Video and BBC iPlayer. Streaming options were updated on",
		id: 'tm1409414',
		timestampRequired: true,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/love',
		title: 'Love - movie: where to watch streaming online',
		descriptionNew:
			'Find where to watch Love on streaming services such as Netflix, Prime Video & BBC iPlayer today. This guide was updated on',
		id: 'tm138998',
		timestampRequired: true,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/one-life-2023',
		title: 'One Life - movie: where to watch streaming online',
		descriptionNew:
			'Find where to watch One Life on streaming services such as Netflix, Prime Video & BBC iPlayer. All streaming options were updated on',
		id: 'tm1369098',
		timestampRequired: true,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/anatomy-of-a-fall',
		title: 'Anatomy of a Fall - movie: watch streaming online',
		descriptionNew:
			'Find where to watch Anatomy of a Fall on streaming services such as Netflix, Prime Video & BBC iPlayer. This guide was updated on',
		id: 'tm1337628',
		timestampRequired: true,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/the-polar-express',
		title: 'The Polar Express - movie: watch streaming online',
		descriptionNew:
			'Where to watch The Polar Express on streaming services such as Netflix, Prime Video and BBC iPlayer. This guide was updated on',
		id: 'tm78713',
		timestampRequired: true,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/animal-2022',
		title: 'Animal - movie: where to watch streaming online',
		descriptionNew:
			'Is "Animal" available to stream on Netflix, Prime Video, BBC iPlayer or any other streaming service? Find out with JustWatch.',
		id: 'tm1129798',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/the-second-wife',
		title: 'The Second Wife - movie: watch streaming online',
		descriptionNew:
			'Is "The Second Wife" available to stream on Netflix, Prime Video, BBC iPlayer or any other streaming service? Find out with JustWatch.',
		id: 'tm55108',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/past-lives',
		title: 'Past Lives - movie: where to watch streaming online',
		descriptionNew:
			'Is "Past Lives" available to stream on Netflix, Prime Video, BBC iPlayer or any other streaming service? Find out with JustWatch.',
		id: 'tm1294945',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/girl-in-the-basement',
		title: 'Girl in the Basement - movie: watch streaming online',
		descriptionNew:
			'Is "Girl in the Basement" available to stream on Netflix, Prime Video, BBC iPlayer or any other streaming service? Find out with JustWatch.',
		id: 'tm1019006',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/dune-2020',
		title: 'Dune - movie: where to watch streaming online',
		descriptionNew:
			'Is "Dune" available to stream on Netflix, Prime Video, BBC iPlayer or any other streaming service? Find out with JustWatch.',
		id: 'tm305113',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/home-alone',
		title: 'Home Alone - movie: where to watch streaming online',
		descriptionNew:
			'Is "Home Alone" available to stream on Netflix, Prime Video, BBC iPlayer or any other streaming service? Find out with JustWatch.',
		id: 'tm155184',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/interstellar',
		title: 'Interstellar - movie: where to watch streaming online',
		descriptionNew:
			'Is "Interstellar" available to stream on Netflix, Prime Video, BBC iPlayer or any other streaming service? Find out with JustWatch.',
		id: 'tm157099',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/the-zone-of-interest',
		title: 'The Zone of Interest - movie: watch streaming online',
		descriptionNew:
			'Is "The Zone of Interest" available to stream on Netflix, Prime Video, BBC iPlayer or any other streaming service? Find out with JustWatch.',
		id: 'tm327806',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/the-holdovers',
		title: 'The Holdovers - movie: watch streaming online',
		descriptionNew:
			'Is "The Holdovers" available to stream on Netflix, Prime Video, BBC iPlayer or any other streaming service? Find out with JustWatch.',
		id: 'tm1261131',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/the-beekeeper',
		title: 'The Beekeeper - movie: watch streaming online',
		descriptionNew:
			'Is "The Beekeepers" available to stream on Netflix, Prime Video, BBC iPlayer or any other streaming service? Find out with JustWatch.',
		id: 'tm180207',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/fast-and-furious-10',
		title: 'Fast X - movie: where to watch streaming online',
		descriptionNew:
			'Is "Fast X" available to stream on Netflix, Prime Video, BBC iPlayer or any other streaming service? Find out with JustWatch.',
		id: 'tm311752',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/dunki',
		title: 'Dunki - movie: where to watch streaming online',
		descriptionNew:
			'WATCH "Dunki" online now with JustWatch\'s complete streaming guide: Find where to watch it for free, how to stream in 4K & more.',
		id: 'tm1216571',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/the-hunger-games',
		title: 'The Hunger Games - movie: watch streaming online',
		descriptionNew:
			'WATCH "The Hunger Games" online now with JustWatch\'s complete streaming guide: Find where to watch it for free, how to stream in 4K & more.',
		id: 'tm57536',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/sam-bahadur',
		title: 'Sam Bahadur - movie: where to watch streaming online',
		descriptionNew:
			'WATCH "Sam Bahadur" online now with JustWatch\'s complete streaming guide: Find where to watch it for free, how to stream in 4K & more.',
		id: 'tm829786',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/charlottes-net',
		title: "Charlotte's Net - movie: watch streaming online",
		descriptionNew:
			'WATCH "Charlotte\'s Net" online now with JustWatch\'s complete streaming guide: Find where to watch it for free, how to stream in 4K & more.',
		id: 'tm964979',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/twilight',
		title: 'Twilight - movie: where to watch streaming online',
		descriptionNew:
			'WATCH "Twilight" online now with JustWatch\'s complete streaming guide: Find where to watch it for free, how to stream in 4K & more.',
		id: 'tm57772',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/five-nights-at-freddys',
		title: "Five Nights at Freddy's - watch streaming online",
		descriptionNew:
			"WATCH \"Five Night's at Freddy's\" online now with JustWatch's complete streaming guide: Find where to watch it for free, how to stream in 4K & more.",
		id: 'tm428148',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/no-way-up',
		title: 'No Way Up - movie: where to watch streaming online',
		descriptionNew:
			'WATCH "No Way Up" online now with JustWatch\'s complete streaming guide: Find where to watch it for free, how to stream in 4K & more.',
		id: 'tm1342837',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/bottoms',
		title: 'Bottoms - movie: where to watch streaming online',
		descriptionNew:
			'WATCH "Bottoms" online now with JustWatch\'s complete streaming guide: Find where to watch it for free, how to stream in 4K & more.',
		id: 'tm1303915',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/spirited-away',
		title: 'Spirited Away - movie: watch streaming online',
		descriptionNew:
			'WATCH "Spirited Away" online now with JustWatch\'s complete streaming guide: Find where to watch it for free, how to stream in 4K & more.',
		id: 'tm48297',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/willy-wonka-and-the-chocolate-factory',
		title: 'Willy Wonka & the Chocolate Factory - streaming',
		descriptionNew:
			'WATCH "Willy Wonka & the Chocolate Factory" online now with JustWatch\'s complete streaming guide: Find where to watch it for free and how to stream in 4K.',
		id: 'tm15070',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/migration',
		title: 'Migration - movie: where to watch streaming online',
		descriptionNew:
			'WATCH "Migration" online now with JustWatch\'s complete streaming guide: Find where to watch it for free, how to stream in 4K & more.',
		id: 'tm1172801',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/national-lampoons-christmas-vacation',
		title: "National Lampoon's Christmas Vacation - streaming",
		descriptionNew:
			'Where to watch "National Lampoon\'s Christmas Vacation" online on streaming services such as Netflix, Prime Video and Disney+ today.',
		id: 'tm147710',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/wish-2023',
		title: 'Wish - movie: where to watch streaming online',
		descriptionNew:
			'Find out how and where to watch "Wish" online on streaming services such as Netflix, Prime Video and Disney+ today - including all 4K and free options.',
		id: 'tm1254240',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/spider-man-into-the-spider-verse-2',
		title: 'Spider-Man: Across the Spider-Verse - streaming',
		descriptionNew:
			'Where to watch "Spider-Man: Across the Spider-Verse" online on streaming services such as Netflix, Prime Video and Disney+ today.',
		id: 'tm949044',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/below-her-mouth',
		title: 'Below Her Mouth - movie: watch streaming online',
		descriptionNew:
			'Where to watch "Below Her Mouth" online on streaming services such as Netflix, Prime Video and Disney+ today - including all 4K and free options.',
		id: 'tm233503',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/gremlins',
		title: 'Gremlins - movie: where to watch streaming online',
		descriptionNew:
			'Find out how and where to watch "Gremlins" online on streaming services such as Netflix, Prime Video and Disney+ today - including all 4K and free options.',
		id: 'tm173440',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/solar',
		title: 'Solar - movie: where to watch streaming online',
		descriptionNew:
			'Find out how and where to watch "Solar" online on streaming services such as Netflix, Prime Video and Disney+ today - including all 4K and free options.',
		id: 'tm229898',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/charlie-and-the-chocolate-factory',
		title: 'Charlie and the Chocolate Factory - streaming',
		descriptionNew:
			'Where to watch "Charlie and the Chocolate Factory" online on streaming services such as Netflix, Prime Video and Disney+ today.',
		id: 'tm160815',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/killers-of-the-flower-moon',
		title: 'Killers of the Flower Moon - watch streaming online',
		descriptionNew:
			'Where to watch "Killers of the Flower Moon" online on streaming services such as Netflix, Prime Video and Disney+ today - including all 4K and free options.',
		id: 'tm327233',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/virgin-territory',
		title: 'Virgin Territory - movie: watch streaming online',
		descriptionNew:
			'Where to watch "Virgin Territory" online on streaming services such as Netflix, Prime Video and Disney+ today - including all 4K and free options.',
		id: 'tm77607',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/dream-scenario',
		title: 'Dream Scenario - movie: watch streaming online',
		descriptionNew:
			'Where to watch "Dream Scenario" online on streaming services such as Netflix, Prime Video and Disney+ today - including all 4K and free options.',
		id: 'tm1293137',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/a-traves-de-tu-mirada',
		title: 'Through My Window 3: Looking at You - streaming',
		descriptionNew:
			'Where to watch "Through My Window 3: Looking at You" online on streaming services such as Netflix, Prime Video and Disney+ today.',
		id: 'tm1419001',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/365-dni',
		title: '365 Days - movie: where to watch streaming online',
		descriptionNew:
			'Find out how and where to watch "365 Days" online on streaming services such as Netflix, Prime Video and Disney+ today - including all 4K and free options.',
		id: 'tm832345',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/the-iron-claw',
		title: 'The Iron Claw - movie: watch streaming online',
		descriptionNew:
			'Where to watch "The Iron Claw" online on streaming services such as Netflix, Prime Video and Disney+ today - including all 4K and free options.',
		id: 'tm1367018',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/ferrari-2023',
		title: 'Ferrari - movie: where to watch streaming online',
		descriptionNew:
			'Find out how and where to watch "Ferrari" online on streaming services such as Netflix, Prime Video and Disney+ today - including all 4K and free options.',
		id: 'tm231790',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/nativity',
		title: 'Nativity! - movie: where to watch streaming online',
		descriptionNew:
			'Find out how and where to watch "Nativity!" online on streaming services such as Netflix, Prime Video and Disney+ today - including all 4K and free options.',
		id: 'tm138604',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/arthur-christmas',
		title: 'Arthur Christmas - movie: watch streaming online',
		descriptionNew:
			'Where to watch "Arthur Christmas" online on streaming services such as Netflix, Prime Video and Disney+ today - including all 4K and free options.',
		id: 'tm174683',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/the-equalizer-3',
		title: 'The Equalizer 3 - movie: watch streaming online',
		descriptionNew:
			'Where to watch "The Equalizer 3" online on streaming services such as Netflix, Prime Video and Disney+ today - including all 4K and free options.',
		id: 'tm1198657',
		timestampRequired: false,
	},
	{
		url: 'https://www.justwatch.com/uk/movie/the-legend-of-maula-jatt',
		title: 'The Legend Of Maula Jatt - watch streaming online',
		descriptionNew:
			'Where to watch "The Legend of Maula Jatt" online on streaming services such as Netflix, Prime Video and Disney+ today - including all 4K and free options.',
		id: 'tm336391',
		timestampRequired: false,
	},
];
